import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from '@notino/react-styleguide';

import { messages } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/TryItFirst/tryItFirstMessages';

import { Container, Description } from './styled';

interface ITryItFirstProps {
  onClick: () => void;
  isChecked: boolean;
}

export const TryItFirst = ({ onClick, isChecked }: ITryItFirstProps) => {
  return (
    <Container>
      <Checkbox checked={isChecked} onChange={onClick} position={0}>
        <FormattedMessage {...messages.tryItFirst} />
      </Checkbox>

      <Description>
        <FormattedMessage {...messages.tryItFirstDescription} />
        <a href="/try-it-first" target="_blank" rel="noopener">
          <FormattedMessage {...messages.tryItFirstAbout} />
        </a>
      </Description>
    </Container>
  );
};
